import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <img src="/images/logo.png" alt="Sarah Parr Designs Logo" className="hero-logo" />
          <h1 className="hero-title">Sarah Parr Designs</h1>
          <p className="hero-subtitle">Contemporary Pattern Designer</p>
          <p className="hero-description">
            Crafting unique, hand-drawn patterns inspired by nature, 
            textiles, and the beauty of everyday life.
          </p>
          <Link to="/portfolio" className="cta-button">
            View Portfolio
          </Link>
        </div>
      </section>

      <section className="about">
        <div className="about-content">
          <div className="about-text">
            <h2>About My Work</h2>
            <p>
              Each pattern is thoughtfully designed with attention to detail, 
              color harmony, and timeless appeal. From delicate florals to 
              bold geometric designs, my work spans multiple styles and 
              applications.
            </p>
            <p>
              My patterns have been featured on textiles, wallpapers, 
              stationery, and home decor items, bringing joy and beauty 
              to everyday objects.
            </p>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="features-grid">
          <div className="feature">
            <h3>Hand-Crafted</h3>
            <p>Every pattern begins with hand-drawn sketches, ensuring authentic character and charm.</p>
          </div>
          <div className="feature">
            <h3>Versatile</h3>
            <p>Designs that work beautifully across multiple mediums and applications.</p>
          </div>
          <div className="feature">
            <h3>Timeless</h3>
            <p>Classic aesthetics combined with contemporary sensibilities for lasting appeal.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
